import { AppNS } from 'app';
import { RadioQuestion } from 'app/ui/components/radio-questions-list/RadioQuestionsList';

import {
    COMPLIANCE, COMPLIANCE_FAIL_MATRIX, POST_CONSTRUCTION, POST_CONSTRUCTION_FAIL_MATRIX, PRE_CONSTRUCTION, PRE_CONSTRUCTION_FAIL_MATRIX
} from '../../../../../agency/bookings/report-details/report-types/doee/common/inspection-questionnaire/types-list.const';

export const PRE_CONSTRUCTION_TYPE = 'Pre-construction Inspection';
export const COMPLIANCE_TYPE = 'Compliance Monitoring Inspection/Routine';
export const POST_CONSTRUCTION_TYPE = 'Final Inspection';

export const getReportType = (
  report: AppNS.JobEventReport
): string | undefined => {
  if (report.eventInspections && report.eventInspections.length) {
    return report.eventInspections[0].inspectionType;
  }
};

export const getTitleByReportType = (report: AppNS.JobEventReport): string => {
  const type = getReportType(report);

  if (type === PRE_CONSTRUCTION_TYPE) {
    return 'Pre-construction ';
  }

  if (type === COMPLIANCE_TYPE) {
    return 'Compliance Monitoring ';
  }

  if (type === POST_CONSTRUCTION_TYPE) {
    return 'Final ';
  }

  return '';
};

export const getFailMatrixByType = (
  report: AppNS.JobEventReport
): boolean[] => {
  const type = getReportType(report);

  if (type === PRE_CONSTRUCTION_TYPE) {
    return PRE_CONSTRUCTION_FAIL_MATRIX;
  }

  if (type === COMPLIANCE_TYPE) {
    return COMPLIANCE_FAIL_MATRIX;
  }

  if (type === POST_CONSTRUCTION_TYPE) {
    return POST_CONSTRUCTION_FAIL_MATRIX;
  }

  return [];
};

export const getQuestionsByType = (
  report: AppNS.JobEventReport
): RadioQuestion[] => {
  const type = getReportType(report);

  if (type === PRE_CONSTRUCTION_TYPE) {
    return PRE_CONSTRUCTION;
  }

  if (type === COMPLIANCE_TYPE) {
    return COMPLIANCE;
  }

  if (type === POST_CONSTRUCTION_TYPE) {
    return POST_CONSTRUCTION;
  }

  return [];
};
